'use client'

import { useCustomRouter, useGetTranslations, usePrintedTicketData } from '@/root/shared-hooks'
import { useErrorBanner } from '@/root/shared-hooks/useErrorBanner/useErrorBanner'
import { Reservation } from '@/root/shared-types'

/** The live reservation behind the confirm page, whether it can still be paid (OFFER) and the payment error banner. */
export const useConfirmPage = (staticReservation: Reservation) => {
  const { reservation, error, isLoading } = usePrintedTicketData(staticReservation)
  const { errorBody } = useErrorBanner()
  const { getTranslation } = useGetTranslations()
  const { query } = useCustomRouter()
  const { errorHandler } = useErrorBanner()
  const { sailPackages } = staticReservation

  const isOffer = reservation?.status === 'OFFER'

  // Called during render, as before the move; only once the reservation is loaded and still OFFER
  if (!error && !isLoading && isOffer) {
    if (query.error === 'PAYMENT_STATUS_FAILURE' && errorHandler) {
      errorHandler({
        error: new Error(),
        time: new Date(),
        message: getTranslation('confirmationBookingPaymentProcessError'),
      })
    }
  }

  return { reservation, error, isLoading, isOffer, errorBody, sailPackages }
}
